module.exports = __webpack_public_path__ + "img/tf_l.cbf04e21.jpg";